// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3_9Xg","row":"styles_row__2Ky8J"};